module.exports = __webpack_public_path__ + "img/COLLEGE BOIS DE BOULOGNE.e3315eb6.webp";